function getLoyaltyInsuranceProductType(insuranceType: App.InsuranceType | undefined): Extract<App.LoyaltyProductType, 'cfmr' | 'insurance'> {
  switch (insuranceType) {
    case 'cfmr':
      return 'cfmr'
    default:
      return 'insurance'
  }
}

export default getLoyaltyInsuranceProductType
